// API configuration for Admin Panel (bo.smartera.uk)
const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://bo-api.smartera.uk',
  get WALLET_API_URL() { return `${this.apiUrl}/wallet`; },
};

// Helper function to build full API URL
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${config.apiUrl}/${cleanEndpoint}`;
};

export default config;
